module.exports = __webpack_public_path__ + "img/ImageQstep4.d70d0d9a.png";